/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Conversion } from './Conversion';
import {
    ConversionFromJSON,
    ConversionFromJSONTyped,
    ConversionToJSON,
} from './Conversion';

/**
 * Representation of the sales unit
 * @export
 * @interface SalesUnits
 */
export interface SalesUnits {
    /**
     * Code of the sales unit
     * @type {string}
     * @memberof SalesUnits
     */
    code?: string;
    /**
     * Name of the sales unit
     * @type {string}
     * @memberof SalesUnits
     */
    defaultSalesUnit?: string;
    /**
     * Description of the sales unit
     * @type {string}
     * @memberof SalesUnits
     */
    salesUnitDescription?: string;
    /**
     * Conversion factor of the sales unit
     * @type {Array<Conversion>}
     * @memberof SalesUnits
     */
    conversions?: Array<Conversion>;
}

/**
 * Check if a given object implements the SalesUnits interface.
 */
export function instanceOfSalesUnits(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SalesUnitsFromJSON(json: any): SalesUnits {
    return SalesUnitsFromJSONTyped(json, false);
}

export function SalesUnitsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesUnits {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'defaultSalesUnit': !exists(json, 'defaultSalesUnit') ? undefined : json['defaultSalesUnit'],
        'salesUnitDescription': !exists(json, 'salesUnitDescription') ? undefined : json['salesUnitDescription'],
        'conversions': !exists(json, 'conversions') ? undefined : ((json['conversions'] as Array<any>).map(ConversionFromJSON)),
    };
}

export function SalesUnitsToJSON(value?: SalesUnits | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'defaultSalesUnit': value.defaultSalesUnit,
        'salesUnitDescription': value.salesUnitDescription,
        'conversions': value.conversions === undefined ? undefined : ((value.conversions as Array<any>).map(ConversionToJSON)),
    };
}

